<template>
  <v-card>
  <v-row class="floatrow">
   <v-dialog
     v-model="dialog"
     scrollable
     max-width="600px"
   >
   <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          class="new_button"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <v-card class="modern-card">
        <v-card-title class="dialog-title">
          <v-icon left color="primary">mdi-cellphone-link</v-icon>
          {{ form_title }}
        </v-card-title>
        <v-card-text class="dialog-content">
          <v-alert
            v-if="saveError"
            type="error"
            dense
            outlined
            class="mb-4"
          >
            {{ saveError }}
          </v-alert>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Nom *"
                required
                v-model=device.name
                outlined
                dense
                prepend-inner-icon="mdi-cellphone"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Fournisseur *"
                required
                v-model=device.manufacturer
                outlined
                dense
                prepend-inner-icon="mdi-factory"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Modèle *"
                required
                v-model=device.model
                outlined
                dense
                prepend-inner-icon="mdi-information"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Numéro de série"
                required
                v-model=device.serial_number
                outlined
                dense
                prepend-inner-icon="mdi-barcode"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Mensualité"
                required
                v-model=device.amount
                outlined
                dense
                prepend-inner-icon="mdi-currency-usd"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                :items="stores"
                item-value="id"
                item-text="name"
                label="Magasin *"
                required
                v-model="device.store_id"
                outlined
                dense
                prepend-inner-icon="mdi-store"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                :items="status"
                item-value="id"
                item-text="name"
                label="Statut *"
                required
                v-model="device.status"
                outlined
                dense
                prepend-inner-icon="mdi-toggle-switch"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="device.next_renewal_date"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="device.next_renewal_date"
                    label="Prochain Renouvellement"
                    readonly
                    outlined
                    dense
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
        <v-date-picker
          v-model="device.next_renewal_date"
          scrollable
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="modal = false"
          >
            Annuler
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.dialog.save(device.next_renewal_date)"
          >
            OK
          </v-btn>
        </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="close" class="cancel-btn">Annuler</v-btn>
          <v-btn
            color="secondary"
            @click="save"
            :loading="loading"
            :disabled="loading"
            class="save-btn"
          >
            <v-icon left small>mdi-check</v-icon>
            Enregistrer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        class="tablesearch"
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="devices"
      :search="search"
    >
    <template v-slot:item.store_id="{ item }">
        {{ getStoreLabel(item.store_id) }}
    </template>
    <template v-slot:item.amount="{ item }">
        {{ item.amount | formatNumber }}
    </template>
    <template v-slot:item.status="{ item }">
      <v-chip
        :class="getStatusColor(item.status)"
      >
        {{ getStatusLabel(item.status) }}
      </v-chip>
    </template>
      <template v-slot:item.actions="{ item }">
    <v-btn
        icon
        x-small
        class="view_button_btn mr-2"
        @click="viewDevice(item)"
        :loading="loadingDevice === item.id"
        title="Voir les détails"
      >
        <v-icon small>mdi-eye</v-icon>
      </v-btn>
    <v-icon
        small
        class="mr-2 edit_button"
        @click="edit(item)"
      >
        mdi-pencil
      </v-icon>
    </template>
    </v-data-table>

    <!-- Modal Détails de l'appareil -->
    <v-dialog v-model="detailsDialog" scrollable max-width="900px">
      <v-card class="details-modal" v-if="selectedDevice">
        <v-card-title class="modal-header">
          <div class="modal-title">
            <v-icon left color="primary">mdi-cellphone-information</v-icon>
            Détails de l'appareil
          </div>
          <v-btn icon @click="detailsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="modal-content">
          <!-- Device Info -->
          <div class="detail-section">
            <h3 class="section-title">
              <v-icon left small color="primary">mdi-cellphone</v-icon>
              Appareil
            </h3>
            <v-row class="detail-grid">
              <v-col cols="12" sm="6" md="4">
                <div class="detail-item">
                  <span class="detail-label">Nom</span>
                  <span class="detail-value">{{ selectedDevice.name }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="detail-item">
                  <span class="detail-label">Type</span>
                  <v-chip small :color="getDeviceTypeColor(selectedDevice.type)" class="white--text">
                    <v-icon left x-small>{{ getDeviceTypeIcon(selectedDevice.type) }}</v-icon>
                    {{ getDeviceTypeLabel(selectedDevice.type) }}
                  </v-chip>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="detail-item">
                  <span class="detail-label">Statut</span>
                  <v-chip small :class="selectedDevice.status ? 'status-active' : 'status-inactive'">
                    {{ getDetailsStatusLabel(selectedDevice.status) }}
                  </v-chip>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="detail-item">
                  <span class="detail-label">Numéro de série</span>
                  <span class="detail-value">{{ selectedDevice.serial_number || '-' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="detail-item">
                  <span class="detail-label">Identifiant</span>
                  <span class="detail-value">{{ selectedDevice.identifier || '-' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="detail-item">
                  <span class="detail-label">Fabricant</span>
                  <span class="detail-value">{{ selectedDevice.manufacturer || '-' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="detail-item">
                  <span class="detail-label">Modèle</span>
                  <span class="detail-value">{{ selectedDevice.model || '-' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="detail-item">
                  <span class="detail-label">Opérateur</span>
                  <span class="detail-value">{{ selectedDevice.operator || '-' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="detail-item">
                  <span class="detail-label">Adresse IP</span>
                  <span class="detail-value">{{ selectedDevice.ip_address || '-' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="detail-item">
                  <span class="detail-label">Adresse MAC</span>
                  <span class="detail-value">{{ selectedDevice.mac_address || '-' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="detail-item">
                  <span class="detail-label">IMEI</span>
                  <span class="detail-value">{{ selectedDevice.imei || '-' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="detail-item">
                  <span class="detail-label">Date création</span>
                  <span class="detail-value">{{ formatDateTime(selectedDevice.created_at) }}</span>
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- Business Info -->
          <div class="detail-section" v-if="selectedDevice.business">
            <h3 class="section-title">
              <v-icon left small color="secondary">mdi-domain</v-icon>
              Compte
            </h3>
            <v-row class="detail-grid">
              <v-col cols="12" sm="6" md="4">
                <div class="detail-item">
                  <span class="detail-label">Nom</span>
                  <span class="detail-value">{{ selectedDevice.business.name }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="detail-item">
                  <span class="detail-label">Contact</span>
                  <span class="detail-value">{{ selectedDevice.business.contact_full_name || '-' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="detail-item">
                  <span class="detail-label">Téléphone</span>
                  <span class="detail-value">{{ selectedDevice.business.phone || '-' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="detail-item">
                  <span class="detail-label">Email</span>
                  <span class="detail-value">{{ selectedDevice.business.email || '-' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="detail-item">
                  <span class="detail-label">Préfixe</span>
                  <span class="detail-value">{{ selectedDevice.business.prefix || '-' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="detail-item">
                  <span class="detail-label">Adresse</span>
                  <span class="detail-value">{{ selectedDevice.business.address || '-' }}</span>
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- Subscriptions -->
          <div class="detail-section" v-if="selectedDevice.subscriptions && selectedDevice.subscriptions.length > 0">
            <h3 class="section-title">
              <v-icon left small color="success">mdi-calendar-check</v-icon>
              Souscriptions ({{ selectedDevice.subscriptions.length }})
            </h3>
            <div class="subscriptions-list">
              <v-expansion-panels accordion>
                <v-expansion-panel v-for="(sub, index) in selectedDevice.subscriptions" :key="index">
                  <v-expansion-panel-header>
                    <div class="subscription-header">
                      <v-chip x-small :color="getSubscriptionStatusColor(sub.status)" class="white--text mr-2">
                        {{ sub.status }}
                      </v-chip>
                      <span class="sub-plan">{{ sub.plan ? sub.plan.name : 'Plan' }}</span>
                      <span class="sub-dates">{{ formatDate(sub.starts_on) }} - {{ formatDate(sub.ends_on) }}</span>
                      <v-chip x-small :color="getPaymentStatusColor(getSubPaymentStatus(sub))" class="white--text ml-2">
                        {{ getSubPaymentStatus(sub) }}
                      </v-chip>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="detail-grid">
                      <v-col cols="12" sm="6" md="4" v-if="sub.plan">
                        <div class="detail-item">
                          <span class="detail-label">Plan</span>
                          <span class="detail-value">{{ sub.plan.name }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="sub.plan">
                        <div class="detail-item">
                          <span class="detail-label">Montant du plan</span>
                          <span class="detail-value amount-value">{{ formatNumber(sub.plan.amount) }} {{ sub.plan.currency }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <div class="detail-item">
                          <span class="detail-label">Début</span>
                          <span class="detail-value">{{ formatDate(sub.starts_on) }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <div class="detail-item">
                          <span class="detail-label">Fin</span>
                          <span class="detail-value">{{ formatDate(sub.ends_on) }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" v-if="sub.payment_request">
                        <v-divider class="my-3"></v-divider>
                        <h4 class="subsection-title">Paiement</h4>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="sub.payment_request">
                        <div class="detail-item">
                          <span class="detail-label">Commande</span>
                          <span class="detail-value">{{ sub.payment_request.order_number }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="sub.payment_request">
                        <div class="detail-item">
                          <span class="detail-label">Montant</span>
                          <span class="detail-value amount-value">{{ formatNumber(sub.payment_request.amount) }} {{ sub.payment_request.currency }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="sub.payment_request">
                        <div class="detail-item">
                          <span class="detail-label">Processeur</span>
                          <v-chip x-small :color="getProcessorColor(sub.payment_request.processor_name)" class="white--text">
                            {{ sub.payment_request.processor_name }}
                          </v-chip>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="sub.payment_request">
                        <div class="detail-item">
                          <span class="detail-label">Statut paiement</span>
                          <div class="payment-status-cell">
                            <v-chip x-small :color="getPaymentStatusColor(sub.payment_request.status)" class="white--text">
                              {{ sub.payment_request.status }}
                            </v-chip>
                            <v-btn
                              v-if="sub.payment_request.status === 'PENDING'"
                              icon
                              x-small
                              color="primary"
                              class="verify-btn ml-1"
                              :loading="verifyingPayments[sub.payment_request.id]"
                              @click="verifyPayment(sub)"
                              title="Vérifier le statut"
                            >
                              <v-icon x-small>mdi-refresh</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="sub.payment_request && sub.payment_request.transaction_id">
                        <div class="detail-item">
                          <span class="detail-label">Transaction ID</span>
                          <span class="detail-value">{{ sub.payment_request.transaction_id }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="sub.payment_request">
                        <div class="detail-item">
                          <span class="detail-label">Date paiement</span>
                          <span class="detail-value">{{ formatDateTime(sub.payment_request.created_at) }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="sub.payment_request && sub.payment_request.payer">
                        <div class="detail-item">
                          <span class="detail-label">Payeur</span>
                          <span class="detail-value">{{ sub.payment_request.payer }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" v-if="sub.payment_request && sub.payment_request.message">
                        <div class="detail-item">
                          <span class="detail-label">Message</span>
                          <span class="detail-value">{{ sub.payment_request.message }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" v-if="isSubscriptionActive(sub)" class="transfer-action-col">
                        <v-divider class="my-3"></v-divider>
                        <v-btn
                          color="primary"
                          outlined
                          small
                          class="transfer-btn"
                          @click.stop="openTransferDialog(sub)"
                        >
                          <v-icon left small>mdi-swap-horizontal</v-icon>
                          Transférer
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
          <div class="detail-section" v-else>
            <h3 class="section-title">
              <v-icon left small color="grey">mdi-calendar-remove</v-icon>
              Souscriptions
            </h3>
            <p class="no-data">Aucune souscription pour cet appareil</p>
          </div>

          <DeviceFeatureSubscriptionsBlock
            v-if="selectedDevice && selectedDevice.serial_number"
            :serial-number="selectedDevice.serial_number"
            :devices-list="devices"
            :current-device-id="selectedDevice.id"
            @transferred="$emit('refresh')"
          />
        </v-card-text>
        <v-card-actions class="modal-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="detailsDialog = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Transfert de souscription -->
    <v-dialog
      v-model="transferDialog"
      max-width="560px"
      scrollable
      content-class="transfer-subscription-dialog"
      @click:outside="closeTransferDialog"
    >
      <v-card v-if="transferSubscription && selectedDevice">
        <v-card-title class="modal-header transfer-modal-header">
          <div class="modal-title">
            <v-icon left color="primary">mdi-swap-horizontal</v-icon>
            Transférer la souscription
          </div>
          <v-btn icon @click="closeTransferDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="transfer-modal-body">
          <div class="detail-section transfer-origin">
            <h4 class="subsection-title">Appareil d'origine</h4>
            <p class="mb-1"><strong>{{ selectedDevice.name }}</strong></p>
            <p class="mb-0 text-caption text--secondary">
              S/N : {{ selectedDevice.serial_number || '—' }}
            </p>
            <p v-if="transferSubscription.plan" class="mt-2 mb-0 text-body-2">
              Plan : {{ transferSubscription.plan.name }}
            </p>
          </div>
          <v-text-field
            v-model="transferDeviceSearch"
            prepend-inner-icon="mdi-magnify"
            label="Rechercher un appareil (nom, série, identifiant)"
            outlined
            dense
            hide-details
            class="mb-3"
            clearable
          ></v-text-field>
          <p class="text-caption text--secondary mb-2">
            Même compte uniquement · {{ filteredTransferDevices.length }} appareil(s)
          </p>
          <v-list dense class="transfer-device-list" v-if="filteredTransferDevices.length">
            <v-list-item
              v-for="d in filteredTransferDevices"
              :key="d.id"
              @click="transferTargetDevice = d"
              :class="{ 'transfer-device-selected': transferTargetDevice && transferTargetDevice.id === d.id }"
            >
              <v-list-item-content>
                <v-list-item-title>{{ d.name }}</v-list-item-title>
                <v-list-item-subtitle>
                  S/N : {{ d.serial_number || '—' }}
                  <span v-if="d.identifier"> · {{ d.identifier }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action v-if="transferTargetDevice && transferTargetDevice.id === d.id">
                <v-icon color="primary">mdi-check-circle</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <p v-else class="no-data py-4">Aucun autre appareil pour ce compte.</p>
        </v-card-text>
        <v-card-actions class="modal-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="closeTransferDialog">Annuler</v-btn>
          <v-btn
            color="primary"
            :disabled="!canSubmitTransfer"
            :loading="transferLoading"
            @click="submitTransfer"
          >
            Transférer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  import store from '@/store/index.js';
  import DeviceFeatureSubscriptionsBlock from '../../components/DeviceFeatureSubscriptionsBlock.vue'

  export default {
    components: { DeviceFeatureSubscriptionsBlock },
    props: {
      devices: [], 
      stores: [],
      business: []
    },
    computed: {
      filteredTransferDevices: function() {
        var self = this
        if (!self.selectedDevice || !self.devices || !self.devices.length) return []
        var q = (self.transferDeviceSearch || '').trim().toLowerCase()
        return self.devices.filter(function(d) {
          if (d.id === self.selectedDevice.id) return false
          if (!q) return true
          var name = (d.name || '').toLowerCase()
          var sn = (d.serial_number || '').toLowerCase()
          var idf = (d.identifier || '').toLowerCase()
          return name.indexOf(q) !== -1 || sn.indexOf(q) !== -1 || idf.indexOf(q) !== -1
        })
      },
      canSubmitTransfer: function() {
        if (!this.transferTargetDevice) return false
        var sn = this.transferTargetDevice.serial_number
        return !!(sn && String(sn).trim().length > 0)
      }
    },
    methods: {
      edit: function(item){
        this.index = this.devices.indexOf(item)
        this.device = Object.assign({}, item)
        this.form_title = "Editer Appareil : "+this.device.name
        this.dialog = true
      },
      close: function(){
        this.dialog = false
        this.reset()
        this.saveError = ''
        this.loading = false
      },
      getStatusColor: function(status){
        var color = "class_red"
        if(status){
          color = "class_green"
        }
        return color
      },
      getStoreLabel: function(item){
        var label = ""
        for (var i = this.stores.length - 1; i >= 0; i--) {
          if(this.stores[i].id == item){
            label = this.stores[i].name
          }
        }
        return label
      },
      getStatusLabel: function(status){
        var label = "Bloqué"
        if(status){
          label = "Actif"
        }
        return label
      },
      getDetailsStatusLabel: function(status) {
        return status ? 'Actif' : 'Bloqué'
      },
      viewDevice: function(item) {
        var self = this
        this.loadingDevice = item.id
        this.$axios.get('/devices/' + item.id + '?include=business,subscriptions.payment_request,subscriptions.plan')
          .then(function(response) {
            self.selectedDevice = response.data
            self.detailsDialog = true
          })
          .catch(function() {
            alert('Erreur lors du chargement des détails')
          })
          .finally(function() {
            self.loadingDevice = null
          })
      },
      formatDate: function(date) {
        if (!date) return '-'
        var d = new Date(date)
        var day = d.getDate().toString().padStart(2, '0')
        var month = (d.getMonth() + 1).toString().padStart(2, '0')
        var year = d.getFullYear()
        return day + '/' + month + '/' + year
      },
      formatDateTime: function(date) {
        if (!date) return '-'
        var d = new Date(date)
        var day = d.getDate().toString().padStart(2, '0')
        var month = (d.getMonth() + 1).toString().padStart(2, '0')
        var year = d.getFullYear()
        var hours = d.getHours().toString().padStart(2, '0')
        var minutes = d.getMinutes().toString().padStart(2, '0')
        return day + '/' + month + '/' + year + ' ' + hours + ':' + minutes
      },
      formatNumber: function(value) {
        if (!value && value !== 0) return '0'
        return parseInt(value).toLocaleString('fr-FR')
      },
      getDeviceTypeLabel: function(type) {
        if (!type) return 'Inconnu'
        var labels = {
          'phone': 'Téléphone', 'tablet': 'Tablette', 'windows': 'Windows',
          'ios': 'iOS', 'linux': 'Linux', 'kiosk': 'Kiosk', 'web': 'Web', 'other': 'Autre'
        }
        return labels[type] || type
      },
      getDeviceTypeColor: function(type) {
        if (!type) return 'grey'
        var colors = {
          'phone': '#2196F3', 'tablet': '#9C27B0', 'windows': '#00BCD4',
          'ios': '#607D8B', 'linux': '#FF5722', 'kiosk': '#795548',
          'web': '#4CAF50', 'other': '#9E9E9E'
        }
        return colors[type] || 'grey'
      },
      getDeviceTypeIcon: function(type) {
        if (!type) return 'mdi-help-circle'
        var icons = {
          'phone': 'mdi-cellphone', 'tablet': 'mdi-tablet',
          'windows': 'mdi-microsoft-windows', 'ios': 'mdi-apple',
          'linux': 'mdi-linux', 'kiosk': 'mdi-monitor',
          'web': 'mdi-web', 'other': 'mdi-devices'
        }
        return icons[type] || 'mdi-devices'
      },
      getSubscriptionStatusColor: function(status) {
        if (!status) return 'grey'
        var s = String(status).toUpperCase()
        if (s === 'ACTIVE') return 'success'
        if (s === 'SCHEDULED') return 'info'
        if (s === 'EXPIRED') return 'warning'
        if (s === 'CANCELLED') return 'error'
        return 'grey'
      },
      getPaymentStatusColor: function(status) {
        if (!status) return 'grey'
        var s = String(status).toUpperCase()
        if (s === 'CONFIRMED') return 'success'
        if (s === 'PENDING') return 'warning'
        if (s === 'DENIED') return 'error'
        return 'grey'
      },
      getProcessorColor: function(processor) {
        if (!processor) return 'grey'
        var p = String(processor).toUpperCase()
        if (p === 'MONCASH') return '#E91E63'
        if (p === 'NATCASH') return '#FF9800'
        if (p === 'CASH') return '#4CAF50'
        return 'grey'
      },
      getSubPaymentStatus: function(sub) {
        if (sub && sub.payment_request && sub.payment_request.status) {
          return sub.payment_request.status
        }
        return '-'
      },
      isSubscriptionActive: function(sub) {
        if (!sub || !sub.status) return false
        return String(sub.status).toUpperCase() === 'ACTIVE'
      },
      verifyPayment: function(sub) {
        var self = this
        if (!sub || !sub.payment_request || !sub.payment_request.id) return
        var paymentId = sub.payment_request.id
        this.$set(this.verifyingPayments, paymentId, true)
        this.$axios.get('/payment-requests/' + paymentId)
          .then(function(response) {
            var updatedPayment = response.data
            if (updatedPayment && self.selectedDevice && self.selectedDevice.subscriptions) {
              for (var i = 0; i < self.selectedDevice.subscriptions.length; i++) {
                if (self.selectedDevice.subscriptions[i].payment_request &&
                    self.selectedDevice.subscriptions[i].payment_request.id === paymentId) {
                  self.$set(self.selectedDevice.subscriptions[i], 'payment_request', updatedPayment)
                  break
                }
              }
            }
          })
          .catch(function() {
            alert('Erreur lors de la vérification du paiement')
          })
          .finally(function() {
            self.$set(self.verifyingPayments, paymentId, false)
          })
      },
      openTransferDialog: function(sub) {
        this.transferSubscription = sub
        this.transferDeviceSearch = ''
        this.transferTargetDevice = null
        this.transferDialog = true
      },
      closeTransferDialog: function() {
        this.transferDialog = false
        this.transferSubscription = null
        this.transferDeviceSearch = ''
        this.transferTargetDevice = null
        this.transferLoading = false
      },
      submitTransfer: function() {
        var self = this
        if (!self.canSubmitTransfer || !self.transferSubscription) return
        var subId = self.transferSubscription.id
        if (subId == null) {
          alert('Souscription invalide (id manquant).')
          return
        }
        var serial = String(self.transferTargetDevice.serial_number).trim()
        self.transferLoading = true
        self.$axios.post('/subscriptions/transfer', {
          subscription_id: subId,
          serial_number: serial
        })
          .then(function(response) {
            var data = response.data
            if (data && data.success) {
              self.closeTransferDialog()
              self.detailsDialog = false
              self.selectedDevice = null
              self.$emit('refresh')
            } else {
              alert((data && (data.message || data.error)) || 'Le transfert a échoué.')
            }
          })
          .catch(function(err) {
            var msg = 'Erreur lors du transfert.'
            if (err.response && err.response.data) {
              var d = err.response.data
              msg = d.message || d.error || msg
            }
            alert(msg)
          })
          .finally(function() {
            self.transferLoading = false
          })
      },
      getAmount: function(amount){
        return "$"+amount
      },
      validateData: function(){
        if(this.device.name == ""){
          alert("Vous devez un nom pour l'appareil")
          return false  
        }

        if(this.device.manufacturer == ""){
          alert("Vous devez indiquer un fournisseur")
          return false
        }

        if(this.device.model == ""){
          alert("Vous devez indiquer le modèle de l'appareil")
          return false
        }

        if(this.device.serial_number == ""){
          alert("Vous devez indiquer le numéro de série de l'appareil")
          return false
        }

        if(this.device.amount == ""){
          alert("Vous devez indiquer le montant de la souscription")
          return false
        }

        return true;
      },
      save: function(){
        var self = this
        if(this.validateData()){
          this.saveError = ''
          this.loading = true
          var url = ''
          var request = null
          if (this.index > -1) { 
            url = '/devices/'+this.device.id
            request = this.$axios.put(url+"?data="+encodeURIComponent(JSON.stringify(self.device)))
          }else{
            url = '/devices'
            this.device.business_id = this.business.id
            this.device.user_id = parseInt(store.getters.StateUser.id)
            request = this.$axios.post(url+"?data="+encodeURIComponent(JSON.stringify(self.device)))
          }
          request
            .then(response => {
              if (self.index > -1) {
                Object.assign(self.devices[self.index], response.data)
              } else {
                self.devices.push(response.data)
              }
              self.dialog = false
              self.reset()
            })
            .catch(function(error){
              console.log(error)
              var message = self.getApiErrorMessage(error)
              self.saveError = message
              if (self.flashMessage) {
                self.flashMessage.error({
                  title: 'Erreur',
                  message: message
                })
              }
            })
            .finally(function () {
              self.loading = false
            })
        }
      },
      getApiErrorMessage: function (error) {
        if (error && error.response && error.response.data) {
          var data = error.response.data
          if (typeof data.message === 'string' && data.message.trim()) {
            return data.message
          }
          if (typeof data.error === 'string' && data.error.trim()) {
            return data.error
          }
        }
        return "Une erreur s'est produite lors de l'enregistrement de l'appareil."
      },
      reset: function(){
        this.device = {
          name: '', 
          manufacturer: '', 
          model: '', 
          serial_number: '', 
          business_id: '', 
          store_id: 0, 
          status: 1,
          amount:6000,
          next_renewal_date:(new Date(Date.now())).toISOString().substr(0, 10),
        }
        this.saveError = ''
        this.index = -1
        this.form_title = 'Nouvel Appareil'
      }
    },
    data () {
      return {
        search: '',
        menu: false,
        modal: false,
        menu2: false,
        loading: false,
        status: [{name: "Actif", id: true}, {name: 'Bloqué', id: false}],
        dialog:'',
        index: -1,
        form_title: 'Nouvel Appareil',
        device: {
          name: '', 
          manufacturer: '', 
          model: '', 
          serial_number: '', 
          business_id: '', 
          store_id: 0, 
          status: 1,
          amount:6000,
          next_renewal_date:(new Date(Date.now())).toISOString().substr(0, 10),
        },
        headers: [
          {
            text: 'NOM',
            align: 'start',
            sortable: false,
            value: 'name',
          },
          { text: 'FOURNISSEUR', value: 'manufacturer' },
          { text: 'MODELE', value: 'model' },
          { text: 'SN', value: 'serial_number' },
          { text: 'MENSUALITE', value: 'amount' },
          { text: 'PROCHAIN RENOUVELLEMENT', value: 'next_renewal_date' },
          { text: 'STATUT', value: 'status' },
          { text: 'ACTIONS', value: 'actions' },
        ],
        detailsDialog: false,
        selectedDevice: null,
        loadingDevice: null,
        verifyingPayments: {},
        transferDialog: false,
        transferSubscription: null,
        transferDeviceSearch: '',
        transferTargetDevice: null,
        transferLoading: false,
        saveError: '',
    }
  }
}
</script>
<style type="text/css">
	.tablesearch .v-input__slot:before{
    display:none;
  }
  .floatrow{
  text-align: right;
   float: right;
   margin-right: 21px;
   margin-left: 5px;
  }
.new_button{
    width:50px;
    margin-top:46px!important;
    float:right;
  }

  .tablesearch .v-input__control{
    border: 1px solid #ddd;
    padding: 5px 10px;
  }
  .edit_button{
    font-size: 16px;
    padding: 5px;
    background: #003f74 !important;
    color: white!important;
    border-radius: 4px;
  }

  .view_button_btn{
    min-width: 28px !important;
    width: 28px !important;
    height: 28px !important;
    background: #fb8c00 !important;
    color: white !important;
    border-radius: 4px;
  }
  .view_button_btn .v-icon { font-size: 16px; }
  td.text-start:last-child, th.text-start:last-child{
    text-align:right!important;
  }
  .v-dialog .v-card__title{
    background:#f3f3f3;
    border-bottom:1px solid #ddd;
  }
  .class_green{
   background:#4caf50 !important;
   color:white!important;
  }
  .class_red{
   background:#ff5252 !important;
   color:white!important;
  }
  .v-btn.close_modal_button{
    background-color:#1976d2!important;
    color:white!important;
  }
  .v-btn.confirm_modal_button{
    background-color:#4caf50!important;
    color:white!important;
  }

  .v-dialog .v-card__actions{
    padding-bottom: 15px!important;
    padding-top: 15px!important;
    background: #f3f3f3;
    border-top: 1px solid #ddd;
  }

  /* Details modal */
  .details-modal { border-radius: 12px !important; }
  .details-modal .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px !important;
    border-bottom: 1px solid rgba(0,0,0,0.08);
  }
  .details-modal .modal-title {
    font-size: 18px;
    font-weight: 600;
    display: flex;
    align-items: center;
  }
  .details-modal .modal-content {
    padding: 24px !important;
    max-height: 70vh;
  }
  .details-modal .detail-section {
    margin-bottom: 24px;
    padding: 16px;
    background: rgba(0,0,0,0.02);
    border-radius: 8px;
  }
  .details-modal .section-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    color: #003F74;
  }
  .details-modal .subsection-title {
    font-size: 14px;
    font-weight: 600;
    color: #666;
    margin-bottom: 12px;
  }
  .details-modal .detail-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .details-modal .detail-label {
    font-size: 12px;
    color: rgba(0,0,0,0.5);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .details-modal .detail-value { font-size: 14px; font-weight: 500; }
  .details-modal .amount-value { color: #003F74; font-weight: 600; }
  .details-modal .subscriptions-list { margin-top: 8px; }
  .details-modal .subscription-header {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
  }
  .details-modal .status-active {
    background: rgba(76,175,80,0.15) !important;
    color: #2E7D32 !important;
  }
  .details-modal .status-inactive {
    background: rgba(255,82,82,0.15) !important;
    color: #D32F2F !important;
  }
  .details-modal .no-data {
    color: rgba(0,0,0,0.5);
    font-style: italic;
    text-align: center;
    padding: 20px;
  }
  .details-modal .payment-status-cell { display: flex; align-items: center; gap: 4px; }
  .details-modal .verify-btn {
    width: 20px !important;
    height: 20px !important;
    background: rgba(0,63,116,0.1) !important;
  }
  .details-modal .transfer-action-col { margin-top: 4px; }
  .details-modal .transfer-btn { text-transform: none !important; }
  .details-modal .modal-actions {
    padding: 16px 24px !important;
    border-top: 1px solid rgba(0,0,0,0.08);
  }

  /* Transfer modal */
  .transfer-subscription-dialog { z-index: 300 !important; }
  .transfer-modal-header { flex-wrap: nowrap; }
  .transfer-modal-body {
    padding: 16px 24px 8px !important;
    max-height: 60vh;
  }
  .transfer-origin { margin-bottom: 16px; }
  .transfer-device-list {
    border: 1px solid rgba(0,0,0,0.08);
    border-radius: 8px;
    max-height: 240px;
    overflow-y: auto;
  }
  .transfer-device-selected {
    background: rgba(0,63,116,0.08) !important;
  }
  .tablesearch .v-input__slot:before{
    display:none;
  }
  .v-card__actions .v-progress-circular{
    margin-top:1px !important;
  }
    .v-card__actions .v-progress-circular circle{
      color:white!important;
    }
</style>